<template>
  <div class="professionals-by-insurance-page">
    <h6>Profissionais por Convênio</h6>
    <div class="columns">
      <div class="column col-12 form-group">
        <div class="insurance-list">
          <div class="scroll-list-wrapper">
            <div class="scroll-list">
              <div class="list-header">
                <label class="form-checkbox">
                  <input type="checkbox"
                         @change="selectAllInsurances"
                         :checked="getInsurancesSelected"
                         :indeterminate.prop="getInsurancesSelected === null">
                  <i class="form-icon"></i>
                </label>
                <div class="list-title">Convênios</div>
                <div class="input-group">
                  <input type="text" class="form-input"
                         v-model="filters.insurance"
                         placeholder="Filtrar convênio">
                  <button class="btn btn-neutral btn-action input-group-btn btn-icon"
                          tabindex="-1" v-if="!filters.insurance.trim()">
                    <fa-icon :icon="['fal', 'search']"/>
                  </button>
                  <button class="btn btn-gray input-group-btn btn-icon"
                          @click="filters.insurance = ''"
                          tabindex="-1" v-else>
                    <fa-icon :icon="['fal', 'times']"/>
                  </button>
                </div>
              </div>
              <table class="table table-hover">
                <tbody>
                <tr v-for="(item, i) in filteredInsurances" :key="i">
                  <td width="30px">
                    <label class="form-checkbox">
                      <input type="checkbox" v-model="item.selected">
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td>{{ item.name }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-gray btn-icon btn-icon-left mr-1"
              :class="{loading: printing && printType === 'sheet'}"
              :disabled="printing"
              @click="print('sheet')">
        <fa-icon :icon="['fal', 'file-excel']"/>Gerar planilha
      </button>
      <button class="btn btn-primary btn-icon-left"
              :class="{loading: printing && printType === 'pdf'}"
              @click="print('pdf')" :disabled="printing">
        <fa-icon :icon="['fal', 'print']"></fa-icon>Imprimir
      </button>
    </div>
  </div>
</template>

<script>
import fuzzy from 'fuzzy';
import formMixin from '@/mixins/form';

export default {
  mixins: [formMixin],
  data() {
    return {
      printing: false,
      insuranceItems: [],
      printType: null,
      filters: {
        insurance: '',
      },
    };
  },
  computed: {
    getInsurancesSelected() {
      if (!this.filteredInsurances || this.filteredInsurances.length === 0) {
        return false;
      }

      const insurancesSelected = this.filteredInsurances.filter(item => item.selected);
      if (insurancesSelected.length === 0) {
        return false;
      }
      if (insurancesSelected.length === this.filteredInsurances.length) {
        return true;
      }
      return null;
    },
    filteredInsurances() {
      let { insuranceItems } = this;

      if (this.filters.insurance.trim()) {
        const results = fuzzy.filter(this.filters.insurance, insuranceItems, {
          extract: (el) => {
            if (el.name) {
              return this.removeAccentuation(el.name);
            }
            return '';
          },
        });
        insuranceItems = results.map(({ original }) => original);
      }

      return insuranceItems;
    },
  },
  mounted() {
    this.loadInsurances();
  },
  methods: {
    selectAllInsurances(e) {
      this.filteredInsurances.forEach((item) => {
        item.selected = e.target.checked;
      });
    },
    loadInsurances() {
      const params = {
        limit: 0,
        active: true,
      };
      return this.$http.get('/insurance-plans', { params })
        .then(({ data }) => {
          this.insuranceItems = data.items.map(item => ({
            id: item.plan.id,
            name: item.customName,
            selected: true,
          }));
        })
        .catch(() => {});
    },
    async print(printType) {
      const selectedInsurance = this.insuranceItems.filter(({ selected }) => selected);

      if (!selectedInsurance || selectedInsurance.length === 0) {
        this.$toast.error('Selecione o(s) convênio(s)!');
        return null;
      }

      this.printType = printType;
      this.printing = true;

      const params = {
        printType,
      };

      if (this.getInsurancesSelected === null) {
        params.planIds = this.insuranceItems
          .filter(({ selected }) => selected)
          .map(item => item.id).join(',');
      }

      if (printType === 'sheet') {
        return this.$file
          .download('/reports/professionals-by-insurance', params, {
            name: 'Profissionais por Convênio.xlsx',
          })
          .catch((e) => {
            this.$toast.error(e);
          })
          .then(() => {
            this.printing = false;
          });
      }
      return this.$file
        .print('/reports/professionals-by-insurance', params)
        .then(() => {
          this.printing = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/variables";
@import '~assets/scss/mixins';
.professionals-by-insurance-page {
  .insurance-list {
    display: flex;
    flex-direction: column;
    height: 18rem;
    overflow-y: auto;
    .list-header {
      align-items: center;
      border-bottom: $border-width solid $border-color;
      display: flex;
      padding-bottom: $layout-spacing;
      .list-title {
        flex: 1;
        font-weight: bold;
      }
    }
    .scroll-list-wrapper {
      border: $border-color solid $border-width;
      border-radius: $border-radius;
      flex-grow: 1;
      position: relative;
    }
    .scroll-list {
      bottom: 0;
      overflow-y: auto;
      padding: $layout-spacing $layout-spacing-lg;
      position: absolute;
      top: 0;
      width: 100%;
      @include scroll-bar();
      .table th, .table td {
        padding: 0;
      }
      .table td {
        border-bottom: none;
      }
    }
  }
  .footer {
    margin-top: $layout-spacing-lg;
    text-align: right;
  }
}
</style>
